import { generatePath } from 'react-router-dom'
import {
    ASSOCIATED_CI_READ_PERMISSION,
    AZURE_INSIGHTS_USE,
    AZURE_INSIGHTS_DASHBOARDS_PERMISSION,
    COLLABORATION_PERMISSION,
    COLLABORATION_RFC_PERMISSION,
    ITSM_SEARCH_TICKETS_READ,
    COST_CONTROL_PERMISSION,
    CUSTOM_DASHBOARDS_PERMISSION,
    CUSTOM_DASHBOARDS_VIEW_MENU,
    DOCUMENTS_CREATE,
    DOCUMENTS_READ,
    DOCUMENTS_READ_ALL,
    DOCUMENTS_UPDATE,
    DOCUMENTS_CATEGORIES_CREATE_UPDATE,
    DOCUMENTS_CATEGORIES_READ,
    GOVERNANCE_ROLES_PERMISSION,
    hasDebugMenu,
    HEALTH_PERMISSION,
    INCIDENT_REPORTING_PERMISSION,
    INVENTORY_CAPACITY_PERMISSION,
    INVENTORY_DEVICES_PERMISSION,
    INVENTORY_DEVICES_READ,
    INVENTORY_SAM_PERMISSION,
    isAllowed,
    isAnyAllowed,
    isAllAllowed,
    isGlobalAdmin,
    MON_PERMISSIONS,
    ORDER_CATALOG_PERMISSION,
    ORDERS_ORDER_CREATE_READ,
    RUNBOOK_PERMISSION,
    SERVICE_DESK_INFO_PERMISSION,
    SERVICE_PORTFOLIO_OVERVIEW,
    GLOBAL_SEARCH_PERMISSION,
    ERP_EXPENSES_PERMISSION,
    CUSTOM_DASHBOARDS_EDITOR_PERMISSION,
    ITP_INTEGRATION_OVERVIEW_PERMISSION,
    ITP_MANAGER_OVERVIEW_PERMISSION,
    KUBEPORT_PERMISSION,
    ITSM_SUPPORT_CENTER_CONTACT_PERMISSION,
    WORKFLOWS_WEBUI_LOGIN,
    DWP_PERMISSION,
    TIMESHEETS_LOCATION_PERMISSION,
    TIMESHEETS_PERMISSION,
    ABSENCES_PERMISSION,
    EMPLOYEE_PROFILE_PERMISSION,
    CSOD_SECURITY_MIGRATED_PAGES_USE,
    CSOD_VIEW_PERMISSION,
    CSOD_ADMIN_PERMISSION,
    CSOD_REGISTER_PERMISSION,
    SECURITY_ACTION_EXCEPTION_USE,
    SECURITY_CSAF_MODULE_DETAIL_USE,
    SECURITY_ADMIN_VM_RECLASSIFICATION,
    SECURITY_BASELINE_DSB,
    SECURITY_BASELINE_CSB,
    SECURITY_CUSTOMER_SCOPING_USE,
    SECURITY_CCF_CUSTOMER_USE,
    INCIDENT_MANAGER_VIEW_PERMISSIONS,
    ERP_VIEW_PERMISSION,
    ERP_PROCUREMENT_USE,
    MANAGER_PROFILE_PERMISSION,
    SECURITY_VULNERABILITY_USE,
    SECURITY_COMPLIANCE_USE,
    SECURITY_MPAM_DASHBOARD_USE,
    SECURITY_DETECT_RESPONSE_USE,
    SECURITY_MENU_PERMISSIONS,
    SUPPORT_WORKSPACE_USE_PERMISSION,
    SECURITY_VM_URGENT_VULNERABILITY,
    SECURITY_VM_LIVE_AGENTS_USE,
    SECURITY_VM_PATCH_INFO_USE,
    SECURITY_COVERAGE_SCOPE_USE,
    SECURITY_COVERAGE_THREAT_USE,
    SECURITY_COVERAGE_USECASE_USE,
    SECURITY_VM_EOL_USE,
    ERP_ABSENCES_PERMISSION,
    SSR_DASHBOARDS_READ_PERMISSION,
} from 'src/utils/permissions'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'

class RouteError extends Error {
    constructor(msg) {
        super('RouteError: ' + msg)
    }
}

export const routeConfig = [
    // CCP-2
    {
        path: '/admin/digital-assistant-import',
        title: 'Digital assistant: import questionnaire',
        component: './mfes/Ccp2Mfe',
        name: 'admin-digital-assistant-import',
        permissions: context => isGlobalAdmin(context),
    },
    {
        path: '/admin/permission-check-remove',
        title: 'Admin: check and remove permissions per session',
        component: './mfes/Ccp2Mfe',
        name: 'permission-check-remove',
        permissions: context => hasDebugMenu(context),
    },
    {
        path: '/admin',
        title: 'admin / debug menu',
        component: './mfes/Ccp2Mfe',
        name: 'admin',
        permissions: context => hasDebugMenu(context),
    },
    {
        path: '/tickets/advanced-search',
        title: 'Tickets: Advanced search',
        component: './mfes/Ccp2Mfe',
        name: 'analyst-tickets-old',
        redirect: {
            name: 'analyst-tickets',
        },
    },
    {
        path: '/subsidiary',
        title: 'Subsidiary',
        component: './mfes/Ccp2Mfe',
        name: 'subsidiary',
    },
    {
        path: '/logout',
        title: 'Logout',
        component: './Logout',
        name: 'logout',
    },
    {
        path: '/cloud-native-platform-orders',
        title: 'Cloud-Native Platform orders',
        component: './mfes/Ccp2Mfe',
        name: 'orders-kubeport',
        permissions: context =>
            isAllowed(context, KUBEPORT_PERMISSION) &&
            isFeatureEnabled(FEATURES.KUBEPORT_MENU_OPTION),
    },
    {
        path: '/orders',
        title: 'Orders',
        component: './mfes/Ccp2Mfe',
        name: 'orders',
        permissions: context => isAllowed(context, ORDERS_ORDER_CREATE_READ),
    },
    {
        path: '/order-details/:id',
        title: 'Orders',
        component: './mfes/Ccp2Mfe',
        name: 'order-detail',
        crossMfeKey: 'ORDER_DETAIL',
    },
    {
        path: '/health/kpi/:kpi_id_uniq',
        title: 'Health detail',
        component: './mfes/Ccp2Mfe',
        name: 'health-detail',
        permissions: context => isAllowed(context, HEALTH_PERMISSION),
    },
    {
        path: '/health/runbooks',
        title: 'Runbooks',
        component: './mfes/Ccp2Mfe',
        name: 'runbook',
        permissions: context => isAllowed(context, RUNBOOK_PERMISSION),
    },
    {
        path: '/health/runbook',
        title: 'Runbooks',
        component: './mfes/Ccp2Mfe',
        name: 'runbook-redirect',
        permissions: context => isAllowed(context, RUNBOOK_PERMISSION),
        redirect: {
            name: 'runbook',
        },
    },
    {
        path: '/health/monitoring',
        title: 'Monitoring',
        component: './mfes/Ccp2Mfe',
        name: 'mon',
        permissions: context =>
            isAnyAllowed(context, MON_PERMISSIONS) &&
            isFeatureEnabled(FEATURES.MON_DASHBOARD_MENU_OPTION),
    },
    {
        path: '/health/kpis',
        title: 'Health',
        component: './mfes/Ccp2Mfe',
        name: 'health',
        permissions: context => isAllowed(context, HEALTH_PERMISSION),
    },
    {
        path: '/health/ssr-dashboards/:id?',
        title: 'SSR Dashboards',
        component: './mfes/Ccp2Mfe',
        name: 'ssr-dashboards',
        permissions: context =>
            isAllAllowed(context, [
                HEALTH_PERMISSION,
                SSR_DASHBOARDS_READ_PERMISSION,
            ]),
    },
    {
        path: '/search/results',
        title: 'Search results',
        component: './mfes/Ccp2Mfe',
        name: 'search',
        permissions: context => isAllowed(context, GLOBAL_SEARCH_PERMISSION),
    },
    {
        path: '/inventory/devices',
        title: 'Devices',
        component: './mfes/Ccp2Mfe',
        name: 'devices',
        permissions: context =>
            isAllAllowed(context, [
                INVENTORY_DEVICES_PERMISSION,
                INVENTORY_DEVICES_READ,
            ]),
    },
    {
        path: '/inventory/capacity',
        title: 'Capacity',
        component: './mfes/Ccp2Mfe',
        name: 'capacity',
        permissions: context =>
            isAllowed(context, INVENTORY_CAPACITY_PERMISSION),
    },
    {
        path: '/inventory/SAM',
        title: 'SAM',
        component: './mfes/Ccp2Mfe',
        name: 'sam',
        permissions: context => isAllowed(context, INVENTORY_SAM_PERMISSION),
    },
    {
        path: '/security/compliance/not-in-compliance',
        title: 'Not in compliance management',
        component: './mfes/Ccp2Mfe',
        name: 'compliance-not-in-compliance',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/vulnerability/overview/scope-configured',
        title: 'Vulnerability scope configured',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-scope-configured',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/scope-scanned',
        title: 'Vulnerability scope scanned',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-scope-scanned',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/top-vulnerabilities/plugin/:dataType/:id',
        title: 'Plugin CIs',
        component: './mfes/Ccp2Mfe',
        name: 'plugin-table',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/total-number-of-vulnerabilities/plugin-cis',
        title: 'Plugin CIs',
        component: './mfes/Ccp2Mfe',
        name: 'total-number-of-vulnerabilities-plugin-table-detail',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/total-number-of-vulnerabilities/plugins',
        title: 'Plugin CIs',
        component: './mfes/Ccp2Mfe',
        name: 'total-number-of-vulnerabilities-plugin-table',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/top-vulnerabilities',
        title: 'All vulnerabilities',
        component: './mfes/Ccp2Mfe',
        name: 'top-vulnerabilities',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/total-vulnerabilities',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-total-vulnerabilities',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/not-in-vulnerability-management',
        title: 'Not in vulnerability management',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-not-in-vulnerability-management',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/total-number-of-vulnerabilities',
        title: 'Total number of vulnerabilities',
        component: './mfes/Ccp2Mfe',
        name: 'total-number-of-vulnerabilities',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/open-vulnerabilities-vs-target-resolution',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-vulnerabilities-vs-target-resolution',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/closed-vulnerabilities-vs-target-resolution',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-vulnerabilities-closed-vs-target-resolution',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/eol/plugin/assets/:id',
        title: 'Impacted CI’s',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-end-of-life-vulnerability-plugin-assets',
        permissions: context => isAllowed(context, SECURITY_VM_EOL_USE),
    },
    {
        path: '/security/vulnerability/overview/eol',
        title: 'End of life vulnerability',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-end-of-life-vulnerability',
        permissions: context => isAllowed(context, SECURITY_VM_EOL_USE),
    },
    {
        path: '/security/vulnerability/overview/external-vulnerabilities/:id',
        component: './mfes/CSOD',
        name: 'vulnerability-external-vulnerabilities-detail',
        crossMfeKey: 'EXTERNAL_VULNERABILITIES_DETAIL',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview/external-vulnerabilities',
        title: 'External Vulnerabilities',
        component: './mfes/CSOD',
        name: 'vulnerability-external-vulnerabilities',
        crossMfeKey: 'EXTERNAL_VULNERABILITIES',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/overview',
        title: 'Vulnerability',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/vulnerability/live-agents',
        title: 'Vulnerability',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-live-agents',
        permissions: context =>
            isAllAllowed(context, [
                SECURITY_VULNERABILITY_USE,
                SECURITY_VM_LIVE_AGENTS_USE,
            ]),
    },
    {
        path: '/security/vulnerability/patching-information',
        title: 'Vulnerability',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-patching-information',
        permissions: context =>
            isAllAllowed(context, [
                SECURITY_VULNERABILITY_USE,
                SECURITY_VM_PATCH_INFO_USE,
            ]),
    },
    {
        path: '/security/vulnerability/urgent-vulnerability',
        title: 'Vulnerability',
        component: './mfes/Ccp2Mfe',
        name: 'vulnerability-urgent-vulnerability',
        permissions: context =>
            isAllAllowed(context, [
                SECURITY_VULNERABILITY_USE,
                SECURITY_VM_URGENT_VULNERABILITY,
            ]),
    },
    {
        path: '/security/overview/closed-security-incidents',
        title: 'Closed security incidents',
        component: './mfes/Ccp2Mfe',
        name: 'closed-security-incidents',
        permissions: context =>
            isAllowed(context, INCIDENT_REPORTING_PERMISSION), // TODO: CSOD-79
    },
    {
        path: '/security/mdr/alerts-incidents-trendline',
        title: 'Alerts & Incidents Trendline',
        component: './mfes/Ccp2Mfe',
        name: 'alertsIncidents',
        permissions: context =>
            isAllowed(context, SECURITY_DETECT_RESPONSE_USE),
    },
    {
        path: '/security/overview/vulnerability/overview',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'overview-vulnerability',
        permissions: context => isAllowed(context, SECURITY_VULNERABILITY_USE),
    },
    {
        path: '/security/overview/vulnerability/live-agents',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'overview-vulnerability-live-agents',
        permissions: context =>
            isAllAllowed(context, [
                SECURITY_VULNERABILITY_USE,
                SECURITY_VM_LIVE_AGENTS_USE,
            ]),
    },
    {
        path: '/security/overview/vulnerability/patching-information',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'overview-vulnerability-patching-information',
        permissions: context =>
            isAllAllowed(context, [
                SECURITY_VULNERABILITY_USE,
                SECURITY_VM_PATCH_INFO_USE,
            ]),
    },
    {
        path: '/security/overview/vulnerability/urgent-vulnerability',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'overview-vulnerability-urgent-vulnerability',
        permissions: context =>
            isAllAllowed(context, [
                SECURITY_VULNERABILITY_USE,
                SECURITY_VM_URGENT_VULNERABILITY,
            ]),
    },
    {
        path: '/security/overview/compliance',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'overview-compliance',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/overview/mpam',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'overview-mpam',
        permissions: context => isAllowed(context, SECURITY_MPAM_DASHBOARD_USE),
    },
    {
        path: '/security/overview/mdr',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'overview-mdr',
        permissions: context =>
            isAllowed(context, SECURITY_DETECT_RESPONSE_USE),
    },
    {
        path: '/security/mpam/incident/:incidentId',
        component: './mfes/CSOD',
        name: 'mpam-incident-detail',
        permissions: context => isAllowed(context, SECURITY_MPAM_DASHBOARD_USE),
        crossMfeKey: 'MPAM_INCIDENT_DETAIL',
    },
    {
        path: '/security/mpam/incident',
        component: './mfes/CSOD',
        name: 'mpam-incident',
        permissions: context => isAllowed(context, SECURITY_MPAM_DASHBOARD_USE),
        crossMfeKey: 'MPAM_INCIDENT',
    },
    {
        path: '/security/overview',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'overview',
        permissions: context =>
            isAnyAllowed(context, SECURITY_MENU_PERMISSIONS),
    },
    {
        path: '/security/mdrdashboard',
        title: 'MDR',
        component: './mfes/Ccp2Mfe',
        name: 'mdr-dashboard',
        permissions: context =>
            isAllowed(context, SECURITY_DETECT_RESPONSE_USE),
    },
    {
        path: '/security/coverage/scope',
        title: 'Coverage',
        component: './mfes/Ccp2Mfe',
        name: 'coverage-scope',
        permissions: context => isAllowed(context, SECURITY_COVERAGE_SCOPE_USE),
    },
    {
        path: '/security/coverage/detection',
        title: 'Coverage',
        component: './mfes/Ccp2Mfe',
        name: 'coverage-detection',
        permissions: context =>
            isAllowed(context, SECURITY_COVERAGE_THREAT_USE),
    },
    {
        path: '/security/coverage/use-case',
        title: 'Coverage',
        component: './mfes/Ccp2Mfe',
        name: 'use-case',
        permissions: context =>
            isAllowed(context, SECURITY_COVERAGE_USECASE_USE),
    },
    {
        path: '/security/coverage',
        title: 'Coverage',
        component: './mfes/Ccp2Mfe',
        name: 'coverage',
        permissions: context =>
            isAllowed(context, SECURITY_DETECT_RESPONSE_USE),
    },
    {
        path: '/security/compliance/cis-baseline/scope-scanned',
        title: 'CIS Baseline Scope Scanned',
        component: './mfes/Ccp2Mfe',
        name: 'cis-scope-scanned',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/compliance/cis-baseline/performed-checks',
        title: 'CIS Baseline Performed Checks',
        component: './mfes/Ccp2Mfe',
        name: 'cis-performed-checks',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/compliance/security-baseline/scope-scanned',
        title: 'Security Baseline Scope Scanned',
        component: './mfes/Ccp2Mfe',
        name: 'security-scope-scanned',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/compliance/security-baseline/performed-checks',
        title: 'Security Baseline Performed Checks',
        component: './mfes/Ccp2Mfe',
        name: 'security-performed-checks',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/compliance/scope-configured',
        title: 'Compliance scope configured',
        component: './mfes/Ccp2Mfe',
        name: 'compliance-scope-configured',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/compliance/scope-scanned',
        title: 'Compliance scope scanned',
        component: './mfes/Ccp2Mfe',
        name: 'compliance-scope-scanned',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/compliance',
        title: 'Compliance',
        component: './mfes/Ccp2Mfe',
        name: 'compliance',
        permissions: context => isAllowed(context, SECURITY_COMPLIANCE_USE),
    },
    {
        path: '/security/admin/:subPath?/:secondSubPath?/:thirdSubPath?',
        title: 'Admin',
        name: 'security-admin',
        component: './mfes/CSOD',
        permissions: context =>
            isAnyAllowed(context, [
                CSOD_ADMIN_PERMISSION,
                CSOD_REGISTER_PERMISSION,
                SECURITY_ACTION_EXCEPTION_USE,
                SECURITY_ADMIN_VM_RECLASSIFICATION,
                SECURITY_BASELINE_DSB,
                SECURITY_BASELINE_CSB,
            ]),
    },

    {
        path: '/security/migration/mdr/alerts-incidents-trendline',
        title: 'Alerts & Incidents Trendline',
        component: './mfes/CSOD',
        name: 'alerts-incidents-trendline',
        permissions: context =>
            isAllowed(context, CSOD_SECURITY_MIGRATED_PAGES_USE),
    },
    {
        path: '/security/migration/mdrdashboard',
        title: 'MDR',
        name: 'migration-mdr-dashboard',
        component: './mfes/CSOD',
        permissions: context =>
            isAllowed(context, CSOD_SECURITY_MIGRATED_PAGES_USE),
    },
    {
        path: '/security/configuration/:subPath?/:secondSubPath?',
        title: 'Configuration',
        component: './mfes/CSOD',
        name: 'configuration',
        permissions: context =>
            isAllowed(context, SECURITY_CUSTOMER_SCOPING_USE),
    },
    {
        path: '/security/threatmission/:missionId',
        component: './mfes/CSOD',
        name: 'threat-mission-details',
        crossMfeKey: 'THREAT_MISSION_DETAILS',
        permissions: context =>
            isAllowed(context, SECURITY_DETECT_RESPONSE_USE),
    },
    {
        path: '/security/csaf/sovereignty/:viewSlug?',
        title: 'Sovereignty',
        component: './mfes/CSOD',
        name: 'csaf-sovereignty',
        permissions: context => isAllowed(context, CSOD_VIEW_PERMISSION),
    },
    {
        path: '/security/csaf/security-roadmap/:tabSlug?',
        title: 'Security roadmap',
        component: './mfes/CSOD',
        name: 'csaf-security-roadmap',
        permissions: context => isAllowed(context, CSOD_VIEW_PERMISSION),
    },
    {
        path: '/security/csaf/improvements',
        title: 'Resilience Improvements',
        component: './mfes/CSOD',
        name: 'csaf-improvements-overview',
        permissions: context => isAllowed(context, CSOD_VIEW_PERMISSION),
    },
    {
        path: '/security/csaf/module/security-control/:viewSlug?',
        title: 'CSAF',
        component: './mfes/CSOD',
        name: 'csaf-module',
        permissions: context => isAllowed(context, CSOD_VIEW_PERMISSION),
    },
    {
        path: '/security/csaf/module/policy-maturity/:viewSlug?/:tabSlug?',
        title: 'CSAF',
        component: './mfes/CSOD',
        name: 'csaf-module',
        permissions: context =>
            isAllowed(context, SECURITY_CSAF_MODULE_DETAIL_USE),
    },
    {
        path: '/security/csaf/module/security-strategy/:viewSlug?',
        title: 'CSAF',
        component: './mfes/CSOD',
        name: 'csaf-module',
        permissions: context =>
            isAllowed(context, SECURITY_CSAF_MODULE_DETAIL_USE),
    },
    {
        path: '/security/csaf/:tabSlug?',
        title: 'CSAF',
        component: './mfes/CSOD',
        name: 'csaf',
        permissions: context => isAllowed(context, CSOD_VIEW_PERMISSION),
    },
    {
        path: '/security/:subPath?',
        title: 'Security MFE',
        component: './mfes/CSOD',
        name: 'csod',
        permissions: context => isAllowed(context, CSOD_VIEW_PERMISSION),
    },
    {
        path: '/cost-control',
        title: 'Cost control',
        component: './mfes/Ccp2Mfe',
        name: 'cost-control',
        permissions: context => isAllowed(context, COST_CONTROL_PERMISSION),
    },
    {
        path: '/service-portfolio/overview/top-products-ordered',
        title: 'Top products ordered',
        component: './mfes/Ccp2Mfe',
        name: 'service-portfolio-top-products-ordered',
        permissions: context => isAllowed(context, SERVICE_PORTFOLIO_OVERVIEW),
    },
    {
        path: '/service-portfolio/overview/top-products-needing-approval',
        title: 'Top products needing approval',
        component: './mfes/Ccp2Mfe',
        name: 'service-portfolio-top-products-needing-approval',
        permissions: context => isAllowed(context, SERVICE_PORTFOLIO_OVERVIEW),
    },
    {
        path: '/service-portfolio/overview',
        title: 'Overview',
        component: './mfes/Ccp2Mfe',
        name: 'service-portfolio-overview',
        permissions: context => isAllowed(context, SERVICE_PORTFOLIO_OVERVIEW),
    },
    {
        path: '/service-portfolio/order-catalog/:categoryId?',
        title: 'Order catalog',
        component: './mfes/Ccp2Mfe',
        name: 'order-catalog',
        permissions: context => isAllowed(context, ORDER_CATALOG_PERMISSION),
    },
    {
        path: '/service-portfolio/:formSlug',
        title: 'Order form',
        component: './mfes/Ccp2Mfe',
        name: 'order-form',
        permissions: context => isAllowed(context, ORDER_CATALOG_PERMISSION),
    },
    {
        path: '/collaboration/governance-roles',
        title: 'Governance roles',
        component: './mfes/Ccp2Mfe',
        name: 'governance-roles-old',
        redirect: {
            name: 'governance-roles',
        },
    },
    {
        path: '/collaboration/overview',
        title: 'Collaboration',
        component: './mfes/Ccp2Mfe',
        name: 'collaboration',
        redirect: {
            name: 'support-center',
        },
    },
    // to be adjusted when migrating to the support center mfe
    {
        path: '/support-center/change/:id',
        title: 'Change',
        component: './mfes/Ccp2Mfe',
        name: 'change-detail',
        crossMfeKey: 'RFC_DETAIL',
    },
    {
        path: '/support-center/changes',
        title: 'Changes',
        component: './mfes/Ccp2Mfe',
        name: 'changes',
        permissions: context =>
            isAllowed(context, COLLABORATION_RFC_PERMISSION),
    },
    {
        path: '/support-center/create-change',
        title: 'Create change',
        component: './mfes/Ccp2Mfe',
        name: 'create-change',
    },
    {
        path: '/support-center/tickets',
        title: 'Tickets',
        component: './mfes/Ccp2Mfe',
        name: 'tickets',
        permissions: context => isAllowed(context, ITSM_SEARCH_TICKETS_READ),
    },
    {
        path: '/support-center/tickets',
        title: 'Tickets',
        component: './mfes/Ccp2Mfe',
        name: 'analyst-tickets',
        permissions: context => isAllowed(context, ITSM_SEARCH_TICKETS_READ),
    },
    {
        path: '/support-center/ticket/:id',
        title: 'Ticket',
        component: './mfes/Ccp2Mfe',
        name: 'ticket-detail',
        crossMfeKey: 'TICKET_DETAIL',
    },
    {
        path: '/support-center/create-ticket-for-org',
        title: 'Create ticket',
        component: './mfes/Ccp2Mfe',
        name: 'create-ticket-for-org',
        permissions: context => isAllowed(context, COLLABORATION_PERMISSION),
    },
    {
        path: '/support-center/create-ticket',
        title: 'Digital assistant',
        component: './mfes/Ccp2Mfe',
        name: 'create-ticket',
        crossMfeKey: 'CREATE_TICKET',
    },
    {
        path: '/support-center/create-incident/:id',
        title: 'Create new incident',
        component: './mfes/Ccp2Mfe',
        name: 'create-incident',
    },
    {
        path: '/support-center/governance-roles',
        title: 'Governance roles',
        component: './mfes/Ccp2Mfe',
        name: 'governance-roles',
        permissions: context => isAllowed(context, GOVERNANCE_ROLES_PERMISSION),
    },
    {
        path: '/support-center/tickets-waiting-for-feedback',
        title: 'Tickets',
        component: './mfes/Ccp2Mfe',
        name: 'tickets-waiting-for-feedback',
        permissions: context => isAllowed(context, COLLABORATION_PERMISSION),
    },
    {
        path: '/support-center/copy-ticket/:id',
        title: 'Copy ticket',
        component: './mfes/Ccp2Mfe',
        name: 'copy-ticket',
    },
    {
        path: '/support-center/overview',
        title: 'Support Center',
        component: './mfes/Ccp2Mfe',
        name: 'support-center',
        permissions: context =>
            isAnyAllowed(context, [
                COLLABORATION_PERMISSION,
                COLLABORATION_RFC_PERMISSION,
                ASSOCIATED_CI_READ_PERMISSION,
                SERVICE_DESK_INFO_PERMISSION,
                ORDERS_ORDER_CREATE_READ,
                ITSM_SEARCH_TICKETS_READ,
            ]),
    },
    {
        path: '/contact-search',
        title: 'Company contacts',
        component: './mfes/Ccp2Mfe',
        name: 'contact-search',
        permissions: context =>
            isAllowed(context, ITSM_SUPPORT_CENTER_CONTACT_PERMISSION),
    },
    {
        path: '/tickets-waiting-for-feedback',
        title: 'Tickets',
        component: './mfes/Ccp2Mfe',
        name: 'tickets-waiting-for-feedback-old',
        redirect: {
            name: 'tickets-waiting-for-feedback',
        },
    },
    {
        path: '/tickets',
        title: 'Tickets',
        component: './mfes/Ccp2Mfe',
        name: 'tickets-old',
        redirect: {
            name: 'analyst-tickets',
        },
    },
    {
        path: '/create-ticket-for-org',
        title: 'Create ticket',
        component: './mfes/Ccp2Mfe',
        name: 'create-ticket-for-org-old',
        redirect: {
            name: 'create-ticket-for-org',
        },
    },
    {
        path: '/create-ticket',
        title: 'Digital assistant',
        component: './mfes/Ccp2Mfe',
        name: 'create-ticket-old',
        redirect: {
            name: 'create-ticket',
        },
    },
    {
        path: '/create-incident/:id',
        title: 'Create new incident',
        component: './mfes/Ccp2Mfe',
        name: 'create-incident-old',
        redirect: {
            name: 'create-incident',
        },
    },
    {
        path: '/dashboard',
        title: 'Home',
        component: './mfes/Ccp2Mfe',
        name: 'dashboard',
    },
    {
        path: '/dashboards/draft',
        title: 'Home',
        component: './mfes/Ccp2Mfe',
        name: 'dashboards-draft',
    },
    {
        path: '/contact-details/:contactId',
        title: 'Contact Details',
        component: './mfes/Ccp2Mfe',
        name: 'contact-details',
        permissions: context =>
            isAllowed(context, ITSM_SUPPORT_CENTER_CONTACT_PERMISSION),
    },
    {
        path: '/custom-dashboards/builder/:id?',
        title: 'Builder',
        component: './mfes/Ccp2Mfe',
        name: 'dashboards-editor',
        permissions: context =>
            isAllowed(context, CUSTOM_DASHBOARDS_EDITOR_PERMISSION) &&
            isFeatureEnabled(FEATURES.LUZMO_EDITOR),
    },
    {
        path: '/news/:id',
        title: 'News item',
        component: './mfes/Ccp2Mfe',
        name: 'news-detail',
        crossMfeKey: 'NEWS_DETAIL',
    },
    {
        path: '/news',
        title: 'News',
        component: './mfes/Ccp2Mfe',
        name: 'news',
    },
    {
        path: '/ticket/:id',
        title: 'Ticket',
        component: './mfes/Ccp2Mfe',
        name: 'ticket-detail-old',
        redirect: {
            name: 'ticket-detail',
        },
    },
    {
        path: '/change/:id',
        title: 'Change',
        component: './mfes/Ccp2Mfe',
        name: 'change-detail-old',
        redirect: {
            name: 'change-detail',
        },
    },
    {
        path: '/changes',
        title: 'Changes',
        component: './mfes/Ccp2Mfe',
        name: 'changes-old',
        redirect: {
            name: 'changes',
        },
    },
    {
        path: '/create-change',
        title: 'Create change',
        component: './mfes/Ccp2Mfe',
        name: 'create-change-old',
        redirect: {
            name: 'create-change',
        },
    },
    {
        path: '/document/create',
        title: 'Create document',
        component: './mfes/Ccp2Mfe',
        name: 'document-create',
        permissions: context =>
            isAnyAllowed(context, [
                DOCUMENTS_CREATE,
                ...DOCUMENTS_CATEGORIES_CREATE_UPDATE,
            ]),
    },
    {
        path: '/document/edit/:id',
        title: 'Edit document',
        component: './mfes/Ccp2Mfe',
        name: 'edit-document',
        permissions: context =>
            isAnyAllowed(context, [
                DOCUMENTS_UPDATE,
                ...DOCUMENTS_CATEGORIES_CREATE_UPDATE,
            ]),
    },
    {
        path: '/documents/:id',
        title: 'Document',
        component: './mfes/Ccp2Mfe',
        name: 'document-detail',
    },
    {
        path: '/documents',
        title: 'Documents',
        component: './mfes/Ccp2Mfe',
        name: 'documents',
        crossMfeKey: 'DOCUMENTS',
        permissions: context =>
            isAnyAllowed(context, [
                DOCUMENTS_READ,
                DOCUMENTS_READ_ALL,
                ...DOCUMENTS_CATEGORIES_READ,
            ]),
    },
    {
        path: '/collaboration/documents',
        title: 'Documents',
        component: './mfes/Ccp2Mfe',
        name: 'documents-old',
        redirect: {
            name: 'documents',
        },
    },
    {
        path: '/mobile',
        title: 'Mobile Onboarding Wizard',
        component: './mfes/Ccp2Mfe',
        name: 'mobile-onboarding-wizard',
    },
    {
        path: '/mobile-link',
        title: 'Mobile Onboarding Wizard 2',
        component: './mfes/Ccp2Mfe',
        name: 'mobile-onboarding-wizard-2',
        options: { hideHeader: true, hideSideMenu: true },
    },
    {
        path: '/gdpr-restriction/:entity?',
        title: 'GDPR Restriction',
        component: './mfes/Ccp2Mfe',
        name: 'gdpr-restriction',
    },
    {
        path: '/security-restriction/:entity?',
        title: 'Security Restriction',
        component: './mfes/Ccp2Mfe',
        name: 'security-restriction',
    },
    {
        path: '/dashboards/cloud-native-platform',
        title: 'Cloud-Native Platform',
        component: './mfes/Ccp2Mfe',
        name: 'dashboards-kubeport',
        permissions: context =>
            isAllowed(context, KUBEPORT_PERMISSION) &&
            isFeatureEnabled(FEATURES.KUBEPORT_MENU_OPTION),
    },
    {
        path: '/azure-insights',
        title: 'Azure Insights',
        component: './mfes/Ccp2Mfe',
        name: 'azure-insights',
        permissions: context =>
            isAllAllowed(context, [
                AZURE_INSIGHTS_USE,
                AZURE_INSIGHTS_DASHBOARDS_PERMISSION,
            ]),
    },
    {
        path: '/azure-insights-report/:reportName',
        title: 'Azure Insights Report',
        component: './mfes/Ccp2Mfe',
        name: 'azure-insights-report',
        permissions: context =>
            isAllAllowed(context, [
                AZURE_INSIGHTS_USE,
                AZURE_INSIGHTS_DASHBOARDS_PERMISSION,
            ]),
    },
    {
        path: '/dashboards/:id?',
        title: 'Horizon Dashboards',
        component: './mfes/Ccp2Mfe',
        name: 'dashboards-discovery',
        permissions: context => isAllowed(context, CUSTOM_DASHBOARDS_VIEW_MENU),
    },
    {
        path: '/digital-workplace/dashboards/:serviceKeyId/:tab?/:subTab?',
        title: 'Digital Workplace',
        component: './mfes/Ccp2Mfe',
        name: 'dashboard-service-details',
        permissions: context => isAllowed(context, DWP_PERMISSION),
    },
    {
        path: '/digital-workplace/dashboards',
        title: 'Digital Workplace',
        component: './mfes/Ccp2Mfe',
        name: 'digital-workplace-dashboards',
        permissions: context => isAllowed(context, DWP_PERMISSION),
    },
    {
        path: '/digital-workplace/custom-dashboard/:id',
        title: 'Custom Dashboard',
        component: './mfes/Ccp2Mfe',
        name: 'digital-workplace-dashboard',
        permissions: context =>
            isAllowed(context, CUSTOM_DASHBOARDS_PERMISSION),
    },
    {
        path: '/digital-workplace',
        title: 'Digital workplace dashboard',
        component: './mfes/Ccp2Mfe',
        name: 'digital-workplace',
        permissions: context => isAllowed(context, DWP_PERMISSION),
    },
    {
        path: '/custom-dashboards/:id',
        title: 'Custom Dashboard',
        component: './mfes/Ccp2Mfe',
        name: 'custom-dashboard',
        permissions: context =>
            isAllowed(context, CUSTOM_DASHBOARDS_PERMISSION),
    },
    // MFE-EXAMPLE - only to be enabled on tst
    {
        path: '/mfe/example/:subPath?',
        component: './mfes/ExampleMfe',
        name: 'example-mfe',
        crossMfeKey: 'EXAMPLE_MFE',
        permissions: () => {
            return isFeatureEnabled(FEATURES.EXAMPLE_MFE_MENU)
        },
    },
    // HR-PORTAL
    {
        path: '/hr-portal/profile/:subPath*',
        title: 'HR Portal',
        component: './mfes/HrPortal',
        name: 'profile-settings-subpaths',
        permissions: context => isAllowed(context, EMPLOYEE_PROFILE_PERMISSION),
        options: {
            showSettingsBar: true,
        },
    },
    {
        path: '/hr-portal/profile',
        title: 'HR Portal',
        component: './mfes/HrPortal',
        name: 'profile-settings',
        permissions: context => isAllowed(context, EMPLOYEE_PROFILE_PERMISSION),
        options: {
            showSettingsBar: true,
        },
    },
    {
        path: '/hr-portal/timesheets',
        component: './mfes/HrPortal',
        name: 'timesheets',
        crossMfeKey: 'TIMESHEETS',
        permissions: context => isAllowed(context, TIMESHEETS_PERMISSION),
        options: {
            closeSideMenu: true,
        },
    },
    {
        path: '/hr-portal/absences',
        component: './mfes/HrPortal',
        name: 'absences',
        crossMfeKey: 'ABSENCES',
        permissions: context => isAllowed(context, ABSENCES_PERMISSION),
    },
    {
        path: '/hr-portal/team/info/:resourceId/:subPaths*',
        title: 'HR Portal',
        component: './mfes/HrPortal',
        name: 'my-team-profiles-personnel-pages',
        permissions: context => isAllowed(context, MANAGER_PROFILE_PERMISSION),
    },
    {
        path: '/hr-portal/team/info/:resourceId',
        title: 'HR Portal',
        component: './mfes/HrPortal',
        name: 'my-team-profiles-personnel-fullName-info',
        permissions: context => isAllowed(context, MANAGER_PROFILE_PERMISSION),
    },
    {
        path: '/hr-portal/team/*',
        title: 'HR Portal',
        component: './mfes/HrPortal',
        name: 'team-management-pages',
        permissions: context => isAllowed(context, MANAGER_PROFILE_PERMISSION),
        exact: false,
    },
    {
        path: '/hr-portal/team',
        title: 'HR Portal',
        component: './mfes/HrPortal',
        name: 'team-management',
        permissions: context => isAllowed(context, MANAGER_PROFILE_PERMISSION),
    },
    {
        path: '/hr-portal/work-location',
        component: './mfes/Timesheets',
        name: 'work-location',
        crossMfeKey: 'WORK_LOCATION',
        permissions: context =>
            isAllowed(context, TIMESHEETS_LOCATION_PERMISSION),
        options: {
            closeSideMenu: true,
        },
    },
    {
        path: '/hr-portal/:subPath*',
        title: 'HR Portal',
        component: './mfes/HrPortal',
        name: 'hr-portal',
    },
    // ITP
    {
        path: '/itp/:subPath?/:secondSubPath?',
        title: 'Integrations',
        component: './mfes/Itp',
        name: 'itp',
        permissions: context =>
            isAnyAllowed(context, [
                ITP_INTEGRATION_OVERVIEW_PERMISSION,
                ITP_MANAGER_OVERVIEW_PERMISSION,
            ]),
    },
    // PLAYBOOK
    {
        path: '/playbook/:subPath?',
        title: 'Playbook',
        component: './mfes/Playbook',
        name: 'playbook',
        //TODO add permissions
    },
    // TASK CENTER
    {
        path: '/task-center/:subPath?/:category?',
        component: './mfes/TaskCenter',
        name: 'task-center',
        crossMfeKey: 'TASK_CENTER',
        permissions: context => isAllowed(context, WORKFLOWS_WEBUI_LOGIN),
    },
    // INCIDENT MANAGER
    {
        path: '/incident-manager/:subPath?/:secondSubPath?',
        title: 'Incident Manager MFE',
        component: './mfes/IncidentManagerMfe',
        name: 'incident-manager',
        permissions: context =>
            isAllowed(context, INCIDENT_MANAGER_VIEW_PERMISSIONS),
    },
    // CCF - Continuous Control Framework
    {
        path: '/ccf/:subPath?',
        title: 'Continuous control framework',
        component: './mfes/CSOD',
        name: 'ccf',
        permissions: context => isAllowed(context, SECURITY_CCF_CUSTOMER_USE),
    },
    {
        path: '/my-exports',
        component: './mfes/Ccp2Mfe',
        name: 'my-exports',
        crossMfeKey: 'MY_EXPORTS',
    },
    {
        path: '/unauthorized',
        title: 'Unauthorized',
        component: './UnauthorizedPage',
        name: 'unauthorized',
    },
    {
        path: '/server-error',
        title: 'Server error',
        component: './ErrorPages/ServerErrorPage',
        name: 'server-error',
    },
    {
        path: '/not-found',
        title: 'Page not found: 404',
        component: './ErrorPages/NotFound',
        name: 'not-found',
    },
    {
        path: '/service-portfolio/:path?',
        component: './mfes/Ccp2Mfe',
        title: 'Order Catalog',
        name: 'order-catalog-content',
        crossMfeKey: 'PRODUCT_LINK',
    },
    {
        path: '/notifications/settings',
        title: 'Notifications',
        component: './mfes/NotificationsMfe',
        crossMfeKey: 'NOTIFICATION_SETTINGS',
        name: 'notifications-settings',
        options: {
            showSettingsBar: true,
        },
    },
    {
        path: '/notifications/:subPath?',
        title: 'Notifications',
        component: './mfes/NotificationsMfe',
        name: 'notifications',
    },
    // ERP PORTAL
    {
        path: '/erp-portal/timesheets/print',
        component: './mfes/ErpPortal',
        name: 'erp-timesheets-print',
        crossMfeKey: 'erp-TIMESHEETS-print',
        permissions: context => isAllowed(context, ERP_VIEW_PERMISSION),
        options: {
            hideHeader: true,
            hideSideMenu: true,
        },
    },
    {
        path: '/erp-portal/absences',
        title: 'Absences',
        component: './mfes/ErpPortal',
        name: 'erp-absences',
        crossMfeKey: 'erp-ABSENCES',
        permissions: context => isAllowed(context, ERP_ABSENCES_PERMISSION),
    },
    {
        path: '/erp-portal/timesheets',
        component: './mfes/ErpPortal',
        name: 'erp-timesheets',
        crossMfeKey: 'erp-TIMESHEETS',
        permissions: context => isAllowed(context, ERP_VIEW_PERMISSION),
        options: {
            closeSideMenu: true,
        },
    },
    {
        path: '/erp-portal/expenses',
        component: './mfes/ErpPortal',
        name: 'expenses',
        crossMfeKey: 'EXPENSES',
        permissions: context => isAllowed(context, ERP_EXPENSES_PERMISSION),
    },
    {
        path: '/erp-portal/procurement',
        title: 'Procurement',
        component: './mfes/ErpPortal',
        name: 'erp-procurement',
        crossMfeKey: 'erp-PROCUREMENT',
        permissions: context => isAllowed(context, ERP_PROCUREMENT_USE),
    },
    {
        path: '/erp-portal/:subPath*',
        title: 'HR Portal',
        component: './mfes/ErpPortal',
        permissions: context => isAllowed(context, ERP_VIEW_PERMISSION),
        name: 'erp-portal',
    },
    {
        path: '/support-workspace/ticket/:id',
        title: 'Ticket',
        component: './mfes/Ccp2Mfe',
        name: 'ticket-detail-support-workspace',
        crossMfeKey: 'TICKET_DETAIL_SUPPORT_WORKSPACE',
    },
    {
        path: '/support-workspace/tickets/:queueName?',
        title: 'Support workspace',
        component: './mfes/Ccp2Mfe',
        name: 'support-workspace-tickets',
        crossMfeKey: 'SUPPORT_WORKSPACE_TICKETS',
        permissions: context =>
            isAllowed(context, SUPPORT_WORKSPACE_USE_PERMISSION),
    },
    {
        path: '/support-workspace/changes/:queueName?',
        title: 'Support workspace',
        component: './mfes/Ccp2Mfe',
        name: 'support-workspace-changes',
        crossMfeKey: 'SUPPORT_WORKSPACE_CHANGES',
        permissions: context =>
            isAllowed(context, SUPPORT_WORKSPACE_USE_PERMISSION),
    },
    {
        path: '/support-workspace/:path?/:subPath?',
        title: 'Support workspace',
        component: './mfes/SupportWorkspace',
        name: 'support-workspace',
        crossMfeKey: 'SUPPORT_WORKSPACE',
    },
    {
        path: '/',
        title: 'Home',
        component: './mfes/Ccp2Mfe',
        name: 'home',
        exact: true,
    },
]

/**
 * @param name
 * @returns {{path: string, component: string, permissions: (function(*): *), name: string, title: string}|{path: string, component: string, permissions: (function(*): *), name: string, title: string}|{path: string, component: string, permissions: (function(*): *), name: string, title: string}|{path: string, component: string, name: string, title: string}|{path: string, component: string, name: string, title: string}}
 */
function findRouteByName(name) {
    const routes = routeConfig.filter(route => route.name === name)
    if (routes.length === 0) {
        throw new RouteError(`No matches found in routeConfig for ${name}`)
    } else if (routes.length > 1) {
        throw new RouteError(
            `Multiple matches found in routeConfig for ${name}: ${routes
                .map(r => r.path)
                .join(', ')}`
        )
    }
    return routes[0]
}

/**
 * Looks up the path of a route using the routeName.
 * @param {string} name - name of the route.
 * @param {Object} params - dynamic params to include in the path
 * @param {Object} queryParams - query parameters
 * @param {string} [hash=''] - hash fragment to append to the URL.
 * @returns {string} - generated URL
 */
export const reverse = (name, params = {}, queryParams = {}, hash = '') => {
    const route = findRouteByName(name)
    const path = generatePath(route.path, params)
    let url = path

    if (Object.entries(queryParams).length) {
        const searchParams = new URLSearchParams(queryParams)
        url += `?${searchParams.toString()}`
    }

    if (hash) {
        url += `#${hash}`
    }

    return url
}

/**
 * Function used for checking permissions using the route name.
 * This unburdens the user from worrying about what permissions to check for a certain route.
 * @param userData
 * @param name
 * @returns {boolean}
 */
export const isRouteAllowed = (userData, name) => {
    const route = findRouteByName(name)
    return 'permissions' in route
        ? route.permissions(userData, route.name)
        : true
}
